/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'sarsaparilla';

import PermitConfirmationItem from './PermitConfirmationItem';
import { formatMoney } from '../../utils/permitUtilsNew';

function ConfirmationBox({
    email,
    orderID,
    reservations,
    subtotal,
    tax,
    total,
    modification,
}) {
    let confirmationTitle = 'Thank you for your order!';
    if (modification) {
        confirmationTitle = "We've updated your order!";
    }
    return (
        <div className={`cartoc-component ${orderID ? '' : 'cartoc-no-order-id'}`}>
            <h1>{confirmationTitle}</h1>
            <h2>
                A confirmation email will be sent out shortly to <strong>{email}</strong>
            </h2>

            <div className="cartoc-ordernum">
                <div>
                    <h3>Order #: {orderID}</h3>
                    <p>
                        <a href="/account/reservations">View My Reservations</a>
                    </p>
                    <button
                        type="button"
                        className="rec-button-primary"
                        onClick={() => window.location.assign('/')}
                    >
                        Continue Shopping
                    </button>
                </div>
            </div>

            <div className="cartoc-social">
                <button type="button" className="rec-button-link" onClick={() => print()}>
                    <Icon iconName="print" />
                </button>
            </div>

            <div className="cartoc-header">
                <div>Reservation Details</div>
            </div>
            <div className="cartoc-details">
                {reservations.map((reservation, index) => {
                    const key = `reservation-${index}`;
                    return <PermitConfirmationItem key={key} reservation={reservation} />;
                })}
                <div className="cartoc-totals">
                    <div className="cartoc-totalscontainer">
                        <div className="cartoc-totalrow">
                            <div className="cartoc-totalheader">Subtotal:</div>
                            <div className="cartoc-totalvalue">
                                {formatMoney(subtotal)}
                            </div>
                        </div>
                        <div className="cartoc-totalrow">
                            <div className="cartoc-totalheader">Tax:</div>
                            <div className="cartoc-totalvalue">{formatMoney(tax)}</div>
                        </div>
                        <div className="cartoc-totalrow cartoc-total">
                            <div className="cartoc-totalheader">Total:</div>
                            <div className="cartoc-totalvalue">{formatMoney(total)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ConfirmationBox.propTypes = {
    email: PropTypes.string.isRequired,
    orderID: PropTypes.string.isRequired,
    reservations: PropTypes.array.isRequired,
    subtotal: PropTypes.string.isRequired,
    tax: PropTypes.string.isRequired,
    total: PropTypes.string.isRequired,
    modification: PropTypes.bool.isRequired,
};

export default ConfirmationBox;
